import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { switchLanguagePath } from '../utils/routes';

const languages = [
  { code: 'it', label: 'IT' },
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
  { code: 'fr', label: 'FR' }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = i18n.language?.substring(0, 2) || 'it';

  const changeLanguage = (langCode) => {
    if (langCode === currentLang) return;
    const newPath = switchLanguagePath(location.pathname, langCode);
    i18n.changeLanguage(langCode);
    navigate(newPath);
  };

  return (
    <div className="flex items-center gap-0" data-testid="language-selector">
      {languages.map((lang, index) => (
        <div key={lang.code} className="flex items-center">
          <motion.button
            onClick={() => changeLanguage(lang.code)}
            className={`text-xs tracking-[0.15em] font-light transition-colors duration-300 px-1.5 py-1 ${
              currentLang === lang.code 
                ? 'text-[#FFD700]' 
                : 'text-white/50 hover:text-[#FFD700]'
            }`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            data-testid={`lang-${lang.code}`}
          >
            {lang.label}
          </motion.button>
          {index < languages.length - 1 && (
            <span className="text-white/30 text-xs font-light">·</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default LanguageSelector;
